<template>
	<div class="zjxNotice">
		<div class="zxj_notice">
			<div class="zxj_notice__title">
				<p>{{detail.news_title}}</p>
			</div>
			<div class="zxj_notice__other">
				<!--<span>文件文号：建协函（2022）59号</span>-->
				<span>点击量：{{detail.read_num}}</span>
				<span>发布时间：{{detail.updated_at}}</span>
				<!--<span>分享到：+*x=</span>-->
			</div>
			<div class="zxj_notice__detail" v-html="detail.news_content">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getAtricDetail
	} from '../../api/moudles/home.js'
	export default {
		data() {
			return {
				detail: {},
				newId: ''
			}
		},
		watch: {
			'$route': function() {
				if (this.newId != this.$route.params.id) {
					this.newId = this.$route.params.id
					this.getAtricDetail(this.$route.params.id)
				}
			}
		},
		created() {
			if (this.$route.params.id) {
				this.newId = this.$route.params.id
				this.getAtricDetail(this.$route.params.id)
			}
		},
		methods: {
			async getAtricDetail(id) {
				await getAtricDetail({
					data: {
						id
					},
					success: res => {
						this.detail = res.data
					}
				})
			}
		}
	}
</script>

<style scoped>
	.zjxNotice {
		min-height: 780px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.zxj_notice {
		width: 1200px;
		min-height: 780px;
		margin-top: 19px;
		background-color: #fff;
		/* display: flex;
		align-items: center;
		justify-content: center; */
	}

	.zxj_notice__title {
		width: 90%;
		margin-left: 5%;

		font-size: 24px;
		font-weight: 600;
		text-align: center;
		line-height: 35px;
		margin-top: 10px;
		padding-bottom: 10px;
		border-bottom: 1px solid #f5f5f5;
	}

	.zxj_notice__other {
		height: 50px;
		line-height: 50px;
		width: 80%;
		margin-left: 10%;
		display: flex;
		justify-content: space-evenly;
	}

	.zxj_notice__other>span {
		font-size: 14px;
		color: #d3d3d3;
	}

	.zxj_notice__detail {
		margin-top: 20px;
		width: 90%;
		margin-left: 5%;
	}

	>>>.zxj_notice__detail>p {
		/* text-indent: 2em; */
		line-height: 30px;
		letter-spacing: 1px;
	}

	>>>.zxj_notice__detail>p>img,
	.zxj_notice__detail>img,
	.zxj_notice__detail>span>img {
		max-width: 100% !important;
	}
</style>
